import assetmanagement from './AssetManagement';
import asset from './Asset';
import Fetch from 'jsx/common/util/_fetch';

const Api = {
  assetmanagement,
  asset,

  runCollector: async (id: string, cb?: any) => {
    try {
      if (!id) throw Error('No ID Provided');
      const result = await Fetch.post(`/api/assets/collector/${id}/run_task/`);
      const data = await result.json();
      if (cb) cb(data);
      return data;
    } catch (e) {
      console.error(e, 'Failed to start asset collector');
    }
  },
};
export default Api;
